module.exports = __webpack_public_path__ + "static/media/friends-struggling.b8cb3511.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/convo-starts/friends-struggling.png
// module id = 1189
// module chunks = 2